import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import en from "./en";
import fr from "./fr";

export const SUPPORTED_LANGUAGES = ["en", "fr"] as const
export const DEFAULT_LANGUAGE = "en"
const LANGUAGE_STORAGE_KEY = "linguascore_language"

/** The language a visitor picked before (or without) signing in; English when they never chose. */
export const storedLanguage = (): string => {
    try {
        const lang = localStorage.getItem(LANGUAGE_STORAGE_KEY)
        if (SUPPORTED_LANGUAGES.includes(lang as typeof SUPPORTED_LANGUAGES[number])) return lang
    } catch {
        // Storage can be blocked (private mode); fall back to the default.
    }
    return DEFAULT_LANGUAGE
}

export const storeLanguage = (lang: string) => {
    try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
    } catch {
        // Not persisted; the choice still applies for this visit.
    }
}

const lang = storedLanguage()
document.documentElement.lang = lang
i18n.on("languageChanged", value => document.documentElement.lang = value)
i18n.use(initReactI18next)
    .init({
        resources: {
            en: {translation: en},
            fr: {translation: fr},
        },
        lng: lang,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        }
    })
export default i18n